import React from "react";
import { connect } from "react-redux";

import { getOverduePayments, isPaymentsReady, isStudentsReady } from "state/school_money/selectors";
import { goToPayment } from "state/school_money/actions";

import Preloader from "components/app/home/Preloader";
import Card from "components/app/home/Card";
import BulletItem from "components/app/home/BulletItem";
import StudentName from "components/school_money/StudentName";
import Date from "components/Date";

class OverduePayments extends React.Component {
  
  renderPayment(payment) {
    const { paymentID, description, dueDate, studentID } = payment.toObject();
    return (
      <div
        key={paymentID}
        className="school_money-home-overdue-payments__link"
        onClick={() => this.props.goToPayment(paymentID)}
      >
        <Card className="school_money-home-overdue-payments__payment">
          <BulletItem cssModifier="school_money">
            <div className="school_money-home-overdue-payments__payment-details">
              <div className="school_money-home-overdue-payments__description">
                <StudentName studentID={studentID} last={false} /> - { description }
              </div>
              <div className="school_money-home-overdue-payments__due-date">
                <Date date={dueDate} />
              </div>
            </div>
          </BulletItem>
        </Card>
      </div>
    )
  }
  
  render() {
    
    const { payments, isReady } = this.props;
    
    if (payments.size === 0) {
      return null;
    }
    
    return (
      <div className="home-section school_money-home-overdue-payments">
        <div className="home-section-heading home-section-heading--school_money school_money-home-overdue-payments__heading">Overdue Payments</div>
        <Preloader isLoading={!isReady}>
          <div className="school_money-home-overdue-payments__body">
            { payments.map(payment => this.renderPayment(payment)) }
          </div>
        </Preloader>
      </div>
    );
    
  }
  
}

export default connect(
  state => ({
    payments: getOverduePayments(state),
    isReady: isPaymentsReady(state) && isStudentsReady(state)
  }),
  { goToPayment }
)(OverduePayments);



// WEBPACK FOOTER //
// ./src/components/app/home/sections/school_money/OverduePayments.js